import SelectBestAnswerItem from './SelectBestAnswerItem';
import SolutionSearchSource from './SolutionSearchSource';

export const components = {
  SelectBestAnswerItem,
  SolutionSearchSource,
};
